import { AppBar, Box, Divider, IconButton, Toolbar } from "@mui/material";
import type { AppBarProps } from "@mui/material";
import { Menu as MenuIcon } from "@mui/icons-material";

import { DRAWER_WIDTH } from "@/constants/layout";
import useHeader from "./useHeader";
import { ProfileMenu } from "./ProfileMenu";

export type HeaderProps = AppBarProps & {
  onDrawerToggle: () => void;
  username: string;
};

/**
 * 공통 헤더
 * @returns
 */
export const Header = (props: HeaderProps) => {
  const { onDrawerToggle, username } = props;
  useHeader();

  const handleDrawerToggle = () => {
    onDrawerToggle();
  };

  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        backgroundColor: "white",
        width: {
          md: `calc(100% - ${DRAWER_WIDTH}px)`,
        },
        ml: {
          md: `${DRAWER_WIDTH}px`,
        },
      }}
    >
      <Toolbar
        sx={{
          justifyContent: "space-between",
        }}
      >
        <IconButton
          color="inherit"
          edge="start"
          onClick={handleDrawerToggle}
          sx={(theme) => ({
            display: {
              md: "none",
            },
            "&:hover": {
              background: theme.palette.grey[300],
            },
          })}
        >
          <MenuIcon />
        </IconButton>
        <span></span>
        <Box sx={{ display: "flex", gap: 2 }}>
          {/* <AlertMenu /> */}
          <ProfileMenu username={username} />
        </Box>
      </Toolbar>
      <Divider />
    </AppBar>
  );
};
